import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

import {JwtModule, JWT_OPTIONS} from '@auth0/angular-jwt';
import {ApiService} from './api_service/api.service';
import {LoggedinService} from './loggedin.service';
//import { AuthGuard } from './auth.guard';
import {RoleService} from './role.service';
import {PollingService} from './polling.service';
import {LoggedinServiceBehavior} from './loggedinbehavior.service';
import {CurrentRouteService} from './currentRoute.service';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

//import { JwtModule } from '@auth0/angular-jwt';

import { MAT_DATE_FORMATS } from '@angular/material/core';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSelectModule} from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from '@angular/material/card';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatGridListModule} from '@angular/material/grid-list';
import {ClipboardModule} from '@angular/cdk/clipboard'
import {MatRippleModule} from '@angular/material/core';
import {MainNavComponent, NotificationsDialog} from './main-nav/main-nav.component';
import {LayoutModule} from '@angular/cdk/layout';
import {MatRadioModule} from '@angular/material/radio';
import {MatBadgeModule} from '@angular/material/badge';
import {
  AccountsComponent,
  AddAccountDialog,
  AddAgencyDetailsDialog,
  DeleteAccountRowDialog,
} from './accounts/accounts.component';
import {AgencysComponent} from './agencys/agencys.component';
import {ReportsComponent} from './reports/reports.component';
import {LoginComponent} from './login/login.component';
import {IntegrationsComponent} from './integrations/integrations.component';
import {TrackerTagComponent} from './tracker-tag/tracker-tag.component';

import {FlexLayoutModule} from '@angular/flex-layout';
import {UserPreferencesComponent} from './user-preferences/user-preferences.component';
import {ChangePasswordComponent} from './change-password/change-password.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {
  ForgotPasswordConfirmationComponent
} from './forgot-password-confirmation/forgot-password-confirmation.component';


import {SnackBarService} from './snackBar.service';
import {MainNavService} from './mainNav.service';
import {AgencyIdService, AccountNameService, AccountIdService} from "./account.service";
import {AccordionHelpComponent} from './reusable/accordion-help/accordion-help.component';

import {EffectsModule} from "@ngrx/effects";
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {AccountEffects} from "./accounts/store/accounts.effects";
import {AgencyEffects} from "./agencys/store/agencys.effects";
// import {accountListReducer} from "./accounts/store/accounts.reducer";
// import {authReducer} from "./login/store/auth.reducer";
import * as fromApp from './store/app.reducer';

import {environment} from '../environments/environment';
import {AuthIntercepterService} from "./http-interceptors/auth-intercepter.service";
import {httpInterceptorProviders} from './http-interceptors/index';
//
// import {HighlightModule, HIGHLIGHT_OPTIONS} from 'ngx-highlightjs';


import {
  HighlightModule,
  HIGHLIGHT_OPTIONS,
  HighlightOptions,
} from 'ngx-highlightjs';
import {
  ReportCampaignsGoogleComponent
} from './report-components/report-campaigns-google/report-campaigns-google.component';
import {
  ReportCampaignsFacebookComponent
} from './report-components/report-campaigns-facebook/report-campaigns-facebook.component';

const MY_FORMATS = {
  parse: {
    dateInput: 'DD MMMM YYYY',
  },
  display: {
    dateInput: 'DD MMMM YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


import { HighchartsChartModule } from 'highcharts-angular';
import { ReportActionsComponent } from './report-components/report-actions/report-actions/report-actions.component';
import { ReportJourneyComponent } from './report-components/report-journey/report-journey.component';
import { ReportAttributionComponent } from './report-components/report-attribution/report-attribution.component';
import { IntegrationsRedirectComponent } from './integrations-redirect/integrations-redirect.component';
import { IntegrationsGoogleadsComponent, AddIntegratinsGoogleAdsDialog } from './integrations-providers/integrations-googleads/integrations-googleads.component';
import { IntegrationsClickfunnelsComponent } from './integrations-providers/integrations-clickfunnels/integrations-clickfunnels.component';
import { IntegrationFacebookComponent } from './integrations-providers/integration-facebook/integration-facebook.component';
import { IntegrationsShopifyComponent } from './integrations-providers/integrations-shopify/integrations-shopify.component';
import { CagadSelectComponent } from './reusable/cagad-select/cagad-select.component';
import { NetworkSelectComponent } from './reusable/network-select/network-select.component';
import { ReportActionsPagingComponent } from './report-components/report-actions-paging/report-actions-paging.component';
import { IncludeFirstClickComponent } from './report-components/includes/attribution/include-first-click/include-first-click.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    MainNavComponent, NotificationsDialog,
    AccountsComponent, AddAccountDialog, DeleteAccountRowDialog, AddAgencyDetailsDialog,
    AgencysComponent,
    ReportsComponent,
    LoginComponent,
    UserPreferencesComponent,
    ChangePasswordComponent,
    AccordionHelpComponent,
    ForgotPasswordComponent,
    ForgotPasswordConfirmationComponent,
    IntegrationsComponent,
    TrackerTagComponent,
    ReportCampaignsGoogleComponent,
    ReportCampaignsFacebookComponent,
    ReportActionsComponent,
    ReportJourneyComponent,
    ReportAttributionComponent,
    IntegrationsRedirectComponent,
    IntegrationsGoogleadsComponent,AddIntegratinsGoogleAdsDialog,
    IntegrationsClickfunnelsComponent,
    IntegrationFacebookComponent,
    IntegrationsShopifyComponent,
    CagadSelectComponent,
    NetworkSelectComponent,
    ReportActionsPagingComponent,
    IncludeFirstClickComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    FormsModule, ReactiveFormsModule,
    MatSnackBarModule, MatToolbarModule, MatSelectModule, MatMenuModule, MatSlideToggleModule,
    MatIconModule, MatButtonModule, MatDialogModule, MatInputModule,
    MatTableModule, MatPaginatorModule, MatSortModule, MatSidenavModule,
    MatListModule, MatProgressSpinnerModule, MatTooltipModule,
    MatProgressBarModule, MatCardModule, MatTabsModule, MatCheckboxModule, MatGridListModule, MatExpansionModule,
    ClipboardModule, MatRippleModule, FlexLayoutModule, MatDatepickerModule,MatNativeDateModule,MatRadioModule,
    MatBadgeModule,
    HighchartsChartModule,
    // StoreModule.forRoot({
    //   accountList: accountListReducer,
    //   auth: authReducer
    // }),
    EffectsModule.forRoot([AccountEffects, AgencyEffects]),
    StoreModule.forRoot(fromApp.appReducer),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    }),
    HighlightModule,
    JwtModule.forRoot({
      config: {
        headerName: 'Authorization',
        authScheme: 'bearer',
        tokenGetter: (() => localStorage.getItem('id_token'))
      }
    }),
    BrowserAnimationsModule,
    LayoutModule
  ],
  providers: [
    LoggedinService,
    ApiService,
    //AuthGuard,
    RoleService,
    LoggedinServiceBehavior,
    PollingService,
    CurrentRouteService,
    SnackBarService,
    MainNavService,
    AgencyIdService, AccountNameService, AccountIdService,
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: <HighlightOptions>{
        lineNumbers: true,
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        lineNumbersLoader: () => import('highlightjs-line-numbers.js'),
        //themePath: 'node_modules/highlight.js/styles/github.css',
        languages: {
          typescript: () => import('highlight.js/lib/languages/typescript'),
          javascript: () => import('highlight.js/lib/languages/javascript'),
          css: () => import('highlight.js/lib/languages/css'),
          xml: () => import('highlight.js/lib/languages/xml'),
        },
      },
    },
    httpInterceptorProviders,
    //{provide: HTTP_INTERCEPTORS, useClass: AuthIntercepterService, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
